<div class="flex flex-col gap-2 min-[22.1875rem]:px-4 pb-2">
    <div class="results-header__toolbar flex items-center justify-between !text-white h-10 !px-1">
        <div class="flex gap-1 items-center">
            <!--
              a11y: audit reported the back/close chevron at the top of every
              results slide-up was an icon-only button with no accessible name.
              Bound ariaLabel + focusInitial (the latter so it can receive
              initial focus when the slide-up acts as a modal dialog with
              cdkTrapFocus and roleDialog=true).
            -->
            <mot-button matType="icon" [icon]="iconName" buttonClass="!text-current !bg-transparent"
                [ariaLabel]="backButtonAriaLabel"
                [focusInitial]="focusInitialOnBack"
                (onClick)="onBackClick.emit()" />

            <ng-content select="[navigationButtons]" />
        </div>

        <div class="flex gap-1 items-center">
            <ng-content select="[buttons]" />
        </div>
    </div>

    <div class="flex flex-col gap-2">
        <ng-content select="[content]" />
    </div>
</div>
